import React from "react";
import { Helmet } from 'react-helmet';

import Nav from "../components/nav/Nav";
import HeroSection from "../components/hero_section/HeroSection";
import Footer from "../components/footer/Footer";

function Top100RednoteMandarinChineseSlangsPage() {
    const slangs = [
        {
            "slang": "小红书 (xiǎo hóng shū)",
            "definition": "Xiaohongshu (Little Red Book). A popular social media and e-commerce platform in China.",
            "example": "Are you on 小红书?"
        },
        {
            "slang": "笔记 (bǐ jì)",
            "definition": "Note, post. A user-generated content piece on Xiaohongshu, often containing images, videos, and text.",
            "example": "I saw this travel tip in a 笔记 on Xiaohongshu."
        },
        {
            "slang": "点赞 (diǎn zàn)",
            "definition": "To like. Clicking the like button on a post.",
            "example": "Don't forget to 点赞 if you find this helpful!"
        },
        {
            "slang": "收藏 (shōu cáng)",
            "definition": "To save, to bookmark. Saving a post for later viewing.",
            "example": "I've 收藏 this recipe, I'll try it later."
        },
        {
            "slang": "关注 (guān zhù)",
            "definition": "To follow. Subscribing to a user's updates.",
            "example": "I'm going to 关注 this creator, their content is great."
        },
        {
            "slang": "评论 (píng lùn)",
            "definition": "Comment. Leaving a message on a post.",
            "example": "There are so many helpful 评论 on this post."
        },
        {
            "slang": "分享 (fēn xiǎng)",
            "definition": "To share. Distributing a post to others or other platforms.",
            "example": "Thanks for 分享 this amazing product!"
        },
        {
            "slang": "发布 (fā bù)",
            "definition": "To publish, to post. Making your content visible on the platform.",
            "example": "I just 发布 a new note about my recent trip."
        },
        {
            "slang": "首页 (shǒu yè)",
            "definition": "Homepage. The main page of the Xiaohongshu app or website.",
            "example": "I always find interesting things on the 首页."
        },
        {
            "slang": "发现 (fā xiàn)",
            "definition": "Discover (section). The section where users can explore new content and trends.",
            "example": "Let's check out the 发现 page to see what's trending."
        },
        {
            "slang": "我 (wǒ)",
            "definition": "Me, my (profile). Refers to the user's personal profile section.",
            "example": "You can find my contact info on 我 page."
        },
        {
            "slang": "消息 (xiāo xī)",
            "definition": "Message, notification. Alerts about new activity on your account.",
            "example": "I have a lot of unread 消息."
        },
        {
            "slang": "搜索 (sōu suǒ)",
            "definition": "To search. Looking for specific content or users.",
            "example": "I'm going to 搜索 for reviews of this product."
        },
        {
            "slang": "话题 (huà tí)",
            "definition": "Hashtag, topic. Keywords used to categorize content.",
            "example": "Use relevant 话题 to reach more people."
        },
        {
            "slang": "合集 (hé jí)",
            "definition": "Collection, album. A curated group of posts on a specific theme.",
            "example": "She has a 合集 of her favorite makeup products."
        },
        {
            "slang": "直播 (zhí bō)",
            "definition": "Live streaming. Real-time video broadcasts.",
            "example": "She's doing a 直播 later to show her new outfits."
        },
        {
            "slang": "粉丝 (fěn sī)",
            "definition": "Fans, followers. Users who subscribe to your content.",
            "example": "Thank you to all my 粉丝 for your support!"
        },
        {
            "slang": "博主 (bó zhǔ)",
            "definition": "Blogger, content creator (on Xiaohongshu). Someone who regularly posts content.",
            "example": "She's a popular beauty 博主."
        },
        {
            "slang": "@ (ài tè)",
            "definition": "At (mentioning a user). Used to tag other users in comments or posts.",
            "example": "@xiaoming, have you tried this?"
        },
        {
            "slang": "赞 (zàn)",
            "definition": "Like (shortened version of 点赞).",
            "example": "Give this post a 赞!"
        },
        {
            "slang": "好看 (hǎo kàn)",
            "definition": "Good-looking, beautiful, attractive.",
            "example": "This dress is so 好看!"
        },
        {
            "slang": "好用 (hǎo yòng)",
            "definition": "Easy to use, useful, effective.",
            "example": "This kitchen gadget is really 好用."
        },
        {
            "slang": "好吃 (hǎo chī)",
            "definition": "Delicious, tasty.",
            "example": "This cake is so 好吃!"
        },
        {
            "slang": "推荐 (tuī jiàn)",
            "definition": "To recommend.",
            "example": "I highly 推荐 this restaurant."
        },
        {
            "slang": "绝绝子 (jué jué zi)",
            "definition": "Amazing, incredible (internet slang). Expresses strong approval.",
            "example": "This concert was 绝绝子!"
        },
        {
            "slang": "YYDS (yǒng yuǎn de shén)",
            "definition": "永远的神, the greatest of all time (internet slang). Used to praise something or someone highly.",
            "example": "This product is YYDS!"
        },
        {
            "slang": "绝了 (jué le)",
            "definition": "Amazing, incredible (shortened version of 绝绝子).",
            "example": "This view is 绝了!"
        },
        {
            "slang": "真的 (zhēn de)",
            "definition": "Really, truly.",
            "example": "This movie is 真的 good."
        },
        {
            "slang": "太…了 (tài…le)",
            "definition": "Too… (e.g., 太好看了 - too beautiful).",
            "example": "This scenery is 太美了!"
        },
        {
            "slang": "get (gěi tè)",
            "definition": "To get it, to understand (often used directly, borrowing from English).",
            "example": "Get it?"
        },
        {
            "slang": "种草 (zhòng cǎo)",
            "definition": "To be influenced to buy something (lit. to plant grass).",
            "example": "This blogger totally 种草 me this lipstick."
        },
        {
            "slang": "拔草 (bá cǎo)",
            "definition": "To decide not to buy something (lit. to pull out grass).",
            "example": "After reading the reviews, I decided to 拔草."
        },
        {
            "slang": "安利 (ān lì)",
            "definition": "To recommend enthusiastically.",
            "example": "Let me 安利 you this amazing skincare product!"
        },
        {
            "slang": "避雷 (bì léi)",
            "definition": "To avoid bad products/experiences (lit. to avoid lightning).",
            "example": "This post is to help you 避雷 this restaurant."
        },
        {
            "slang": "踩雷 (cǎi léi)",
            "definition": "To encounter a bad product/experience (lit. to step on lightning).",
            "example": "I totally 踩雷 with this sunscreen."
        },
        {
            "slang": "平价 (píng jià)",
            "definition": "Affordable, budget-friendly.",
            "example": "This is a great 平价 alternative."
        },
        {
            "slang": "贵 (guì)",
            "definition": "Expensive.",
            "example": "This bag is too 贵 for me."
        },
        {
            "slang": "值 (zhí)",
            "definition": "Worth it.",
            "example": "This product is definitely 值 it."
        },
        {
            "slang": "不值 (bù zhí)",
            "definition": "Not worth it.",
            "example": "This movie is 不值 seeing in theaters."
        },
        {
            "slang": "爱了爱了 (ài le ài le)",
            "definition": "Love it, love it (expressing strong liking).",
            "example": "This color is so pretty, 爱了爱了!"
        },
        {
            "slang": "好物 (hǎo wù)",
            "definition": "Good things, recommended products.",
            "example": "Sharing some of my recent 好物."
        },
        {
            "slang": "测评 (cè píng)",
            "definition": "Review, evaluation.",
            "example": "I'm going to do a 测评 of this new lipstick."
        },
        {
            "slang": "开箱 (kāi xiāng)",
            "definition": "Unboxing.",
            "example": "Here's my 开箱 video of the new iPhone."
        },
        {
            "slang": "功课 (gōng kè)",
            "definition": "Research (before buying).",
            "example": "I did a lot of 功课 before buying this skincare."
        },
        {
            "slang": "链接 (liàn jiē)",
            "definition": "Link.",
            "example": "Can you share the 链接 to this product?"
        },
        {
            "slang": "店铺 (diàn pù)",
            "definition": "Store, shop.",
            "example": "I bought this from their official 店铺."
        },
        {
            "slang": "购买 (gòu mǎi)",
            "definition": "To buy, to purchase.",
            "example": "Where did you 购买 this?"
        },
        {
            "slang": "回购 (huí gòu)",
            "definition": "To repurchase.",
            "example": "This is my third time to 回购 this serum."
        },
        {
            "slang": "无限回购 (wú xiàn huí gòu)",
            "definition": "Will repurchase endlessly.",
            "example": "This is my 无限回购 product!"
        },
        {
            "slang": "姐妹们 (jiě mèi men)",
            "definition": "Sisters (used to address female followers/friends).",
            "example": "姐妹们, check out this deal!"
        },
        {
            "slang": "集美们 (jí měi men)",
            "definition": "Homophone of 姐妹们, also meaning sisters.",
            "example": "集美们, have you tried this?"
        },
        {
            "slang": "求链接 (qiú liàn jiē)",
            "definition": "Asking for the link.",
            "example": "求链接!"
        },
        {
            "slang": "求渠道 (qiú qú dào)",
            "definition": "Asking for the purchase channel.",
            "example": "求渠道!"
        },
        {
            "slang": "多少钱 (duō shǎo qián)",
            "definition": "How much money? How much does it cost?",
            "example": "想问一下 多少钱?"
        },
        {
            "slang": "包邮 (bāo yóu)",
            "definition": "Free shipping.",
            "example": "This item offers 包邮."
        },
        {
            "slang": "正品 (zhèng pǐn)",
            "definition": "Authentic product, genuine.",
            "example": "We guarantee all our products are 正品."
        },
        {
            "slang": "旗舰店 (qí ji艦 diàn)",
            "definition": "Official store, flagship store.",
            "example": "You can buy the 正品 at their 旗舰店."
        },
        {
            "slang": "姐妹 (jiě mèi)",
            "definition": "Sister (used for close female friends).",
            "example": "Love you, 姐妹!"
        },
        {
            "slang": "宝藏 (bǎo zàng)",
            "definition": "Treasure (used to describe something/someone great).",
            "example": "This restaurant is a hidden 宝藏!"
        },
        {
            "slang": "哭了 (kū le)",
            "definition": "Crying (expressing strong emotion, often positive).",
            "example": "This scene is so touching, 哭了!"
        },
        {
            "slang": "笑死 (xiào sǐ)",
            "definition": "Laughing to death (extremely funny).",
            "example": "This video is 笑死我了!"
        },
        {
            "slang": "笑不活了 (xiào bù huó le)",
            "definition": "Similar to 笑死, extremely funny.",
            "example": "Your comment 笑不活了!"
        },
        {
            "slang": "呜呜呜 (wū wū wū)",
            "definition": "Onomatopoeia for crying, expressing sadness or excitement.",
            "example": "This is so cute, 呜呜呜!"
        },
        {
            "slang": "awsl (ā wǒ sǐ la)",
            "definition": "啊我死了啦, ah, it kills me (expressing overwhelming excitement or cuteness).",
            "example": "Look at this puppy, awsl!"
        },
        {
            "slang": "磕到了 (kē dào le)",
            "definition": "Shipping them (referring to liking a romantic pairing).",
            "example": "I'm totally 磕到了 this couple!"
        },
        {
            "slang": "入股不亏 (rù gǔ bù kuī)",
            "definition": "Investing in this is not a loss (strongly recommending something).",
            "example": "Trust me, try this restaurant, 入股不亏!"
        },
        {
            "slang": "OMG (ōu mǎi gā)",
            "definition": "Oh my god (often used directly).",
            "example": "OMG, look at that!"
        },
        {
            "slang": "yummy (yā mī)",
            "definition": "Delicious (often used directly).",
            "example": "This looks yummy!"
        },
        {
            "slang": "respect (ruì sī pǎi kè tè)",
            "definition": "Respect (often used directly).",
            "example": "Respect!"
        },
        {
            "slang": "无语 (wú yǔ)",
            "definition": "Speechless.",
            "example": "I'm 无语 at this situation."
        },
        {
            "slang": "绝 (jué)",
            "definition": "Amazing, superb (short).",
            "example": "This performance is 绝!"
        },
        {
            "slang": "YYDS (yǒng yuǎn dī shén)",
            "definition": "(Alternative spelling, same meaning as #26).",
            "example": "This product is YYDS!"
        },
        {
            "slang": "zqsg (zhēn qíng shí gǎn)",
            "definition": "真情实感, true feelings (often used sarcastically).",
            "example": "My zqsg is overflowing for this drama (sarcastically)."
        },
        {
            "slang": "cp (sī pī)",
            "definition": "Couple, romantic pairing.",
            "example": "They are my favorite CP."
        },
        {
            "slang": "磕CP (kē CP)",
            "definition": "To ship a couple.",
            "example": "I love 磕CP!"
        },
        {
            "slang": "get√ (gěi tè √)",
            "definition": "Got it, understood (using the checkmark symbol).",
            "example": "Get√"
        },
        {
            "slang": "蹲 (dūn)",
            "definition": "To wait for something (e.g., new releases, updates).",
            "example": "蹲一个新色号!"
        },
        {
            "slang": "mark (mǎ kè)",
            "definition": "To mark, to save for later (often used directly).",
            "example": "Mark!"
        },
        {
            "slang": "姐妹们冲啊 (jiě mèi men chōng a)",
            "definition": "Sisters, let's go! (rallying cry).",
            "example": "姐妹们冲啊，买它!"
        },
        {
            "slang": "YY (yǒu yì)",
            "definition": "Interesting, meaningful.",
            "example": "这个分析挺 YY 的."
        },
        {
            "slang": "绝绝 (jué jué)",
            "definition": "(Shortened version of 绝绝子).",
            "example": "This is 绝绝!"
        },
        {
            "slang": "上头 (shàng tóu)",
            "definition": "Addictive, obsessed with something.",
            "example": "This song is so 上头!"
        },
        {
            "slang": "入 (rù)",
            "definition": "To get into (something), to join (a trend).",
            "example": "我 入 了这个坑了."
        },
        {
            "slang": "爆 (bào)",
            "definition": "Exploding in popularity, very popular.",
            "example": "这个产品最近很 爆."
        },
        {
            "slang": "亲测 (qīn cè)",
            "definition": "Personally tested.",
            "example": "亲测好用!"
        },
        {
            "slang": "走过路过不要错过 (zǒu guò lù guò bù yào cuò guò)",
            "definition": "Don't miss it! (common phrase for promoting things).",
            "example": "走过路过不要错过，限时折扣!"
        },
        {
            "slang": "YY一下 (YY yī xià)",
            "definition": "To imagine, to fantasize.",
            "example": "让我 YY一下 中奖的场景."
        },
        {
            "slang": "可 (kě)",
            "definition": "Can, okay, used to express agreement or affirmation.",
            "example": "这个 可以试试."
        },
        {
            "slang": "冲 (chōng)",
            "definition": "Go for it! Buy it! (encouraging action).",
            "example": "冲啊!"
        },
        {
            "slang": "蹲一个 (dūn yī gè)",
            "definition": "Waiting for one (specific item or piece of information).",
            "example": "蹲一个折扣码!"
        },
        {
            "slang": "YYDS！ (yǒng yuǎn de shén!)",
            "definition": "The greatest of all time! (with exclamation).",
            "example": "这个设计 YYDS！"
        },
        {
            "slang": "狠狠 (hěn hěn)",
            "definition": "Severely, intensely (e.g., 狠狠推荐 - strongly recommend).",
            "example": "我狠狠推荐这个!"
        },
        {
            "slang": "无脑 (wú nǎo)",
            "definition": "Brainless, without thinking (often used for easy-to-use or foolproof products).",
            "example": "这个操作很无脑."
        },
        {
            "slang": "yyds forever (yǒng yuǎn de shén forever)",
            "definition": "(English added for emphasis).",
            "example": "This drama is yyds forever!"
        },
        {
            "slang": "YYDSyyds (yǒng yuǎn de shén yǒng yuǎn de shén)",
            "definition": "Repeating for emphasis.",
            "example": "这个功能 YYDSyyds!"
        },
        {
            "slang": "真的绝了 (zhēn de jué le)",
            "definition": "Truly amazing.",
            "example": "这景色 真的绝了!"
        },
        {
            "slang": "笑鼠我了 (xiào shǔ wǒ le)",
            "definition": "Laughing like a mouse (similar to 笑死我了).",
            "example": "这个评论 笑鼠我了!"
        },
        {
            "slang": "救命 (jiù mìng)",
            "definition": "Help! (often used humorously to express being overwhelmed by cuteness or excitement).",
            "example": "太可爱了，救命!"
        },
        {
            "slang": "宝藏女孩/男孩 (bǎo zàng nǚ hái/nán hái)",
            "definition": "Treasure girl/boy (describing someone great).",
            "example": "She's such a 宝藏女孩!"
        },
        {
            "slang": "YYDS! (永远滴神! - yǒng yuǎn dī shén!)",
            "definition": "(Alternative character for 'de,' same meaning as #26).",
            "example": "这个游戏 YYDS!"
        }
    ]
      
    return (
      <div >
        <Helmet>
            <meta name="google-adsense-account" content="ca-pub-5419912423604609"></meta>
            <meta charSet="UTF-8"/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
            <meta name="description" content="Discover the essential terms of Xiaohongshu (REDnote) to decode posts, leave engaging comments, and boost your interaction rate. Become a Xiaohongshu expert with XHSLingo.com."/>
            <meta name="keywords" content="Xiaohongshu terms, XiaoHongShu phrases, Chinese social media language, learn Xiaohongshu, top 100 REDnote terms, beginner guide to Xiaohongshu, Chinese online terms, Xiaohongshu interaction, XiaoHongShu engagement tips, XHSLingo, understand Xiaohongshu, navigate Xiaohongshu, English speakers Xiaohongshu"/>
            <meta name="author" content="XiaoHongShu Lingo Team"/>
            <meta property="og:site_name" content="XiaoHongShu Lingo" />
            <meta property="og:title" content="Decode Xiaohongshu Posts with These 100 Essential Terms!"/>
            <meta property="og:description" content="Master the language of Xiaohongshu (REDnote)! Learn the key terms to boost your interactions and connect with the community on XHSLingo.com."/>
            <meta property="og:image" content="https://xhslingo.com/logo512.png"/>
            <meta property="og:url" content="https://xhslingo.com/top-100-rednote-mandarin-chinese-terms"/>
            <meta property="og:type" content="article"/>
            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:title" content="Decode Xiaohongshu Posts with These Essential Terms!"/>
            <meta name="twitter:description" content="Unlock Xiaohongshu's language with XHSLingo's easy-to-follow guide. Perfect for English speakers to connect and engage!"/>
            <meta name="twitter:image" content="https://xhslingo.com/logo512.png"/>
            <title>Decode Xiaohongshu: Your Guide to the Top 100 REDnote Terms</title>
            <link rel="canonical" href="https://xhslingo.com/top-100-rednote-mandarin-chinese-terms"/>
        </Helmet>

        <Nav />
        <HeroSection
            title="Decode Rednote: Your Guide to the Top 100 Popular Slangs"
            backgroundColor="bg-red-500"  // 可选传递其他颜色
            textColor="text-white"          // 可选传递其他文字颜色
        />
        <section className="py-12 bg-white">
            <div className="container mx-auto px-6 max-w-5xl">
                <h2 className="text-2xl font-bold mb-6">Top 100 Slang List</h2>
                <div className="space-y-6">
                {slangs.map((item, index) => (
                    <div
                    key={index}
                    className="p-6 border border-gray-200 rounded-lg shadow-sm bg-gray-50"
                    >
                    <h3 className="text-xl font-semibold text-gray-800">
                        {item.slang}
                    </h3>
                    <p className="text-gray-600 mt-2">
                        <strong>Definition:</strong> {item.definition}
                    </p>
                    <p className="text-gray-600 mt-2">
                        <strong>Example:</strong> {item.example}
                    </p>
                    </div>
                ))}
                </div>
            </div>
        </section>
        <Footer />
    </div>
    );
  }
  
export default Top100RednoteMandarinChineseSlangsPage;